import React from "react";
import WalletPage from "./WalletPage";

export default function PayPals() {
  return (
    <WalletPage
      type="paypal"
      title="PayPal"
      subtitle="PayPal accounts — card, status, and linked CashApps"
      prefix="paypal"
      enableCard
      enableCashappLinks
    />
  );
}
